module.exports = __webpack_public_path__ + "static/media/spades_9.c820e8ac.png";